module.exports = __webpack_public_path__ + "static/media/alertSound1.e7cdccfb.wav";